import { defineComponent as i, createBlock as n, openBlock as a, unref as t, withCtx as s, createVNode as l, renderSlot as m } from "vue";
import "./highrise34.mjs";
import { COMPONENT_NAME as p } from "./highrise178.mjs";
import { NIconWrapper as u } from "./highrise683.mjs";
import d from "./highrise125.mjs";
const f = i({
  name: p.FEATURE_ICON,
  inheritAttrs: !0
}), b = /* @__PURE__ */ i({
  ...f,
  props: {
    size: { default: "md" },
    shape: { default: "circle" },
    color: {},
    bgColor: {},
    customSizeContainer: {},
    customSizeIcon: {}
  },
  setup(c) {
    const o = c, e = {
      lg: 48,
      md: 40,
      sm: 32,
      xs: 24,
      "2xs": 16,
      "3xs": 12
    };
    return (r, z) => (a(), n(t(u), {
      "border-radius": r.shape == "circle" ? 50 : 0,
      size: o.customSizeContainer || e[o.size],
      color: o.bgColor
    }, {
      default: s(() => [
        l(t(d), {
          size: o.customSizeIcon || String(e[o.size] / 2),
          color: o.color
        }, {
          default: s(() => [
            m(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["size", "color"])
      ]),
      _: 3
    }, 8, ["border-radius", "size", "color"]));
  }
});
export {
  b as default
};
